import { useRouter } from 'next/router';
import { Dispatch } from 'react';
import DesktopFilter from '../../../components/careerguide/DesktopFiltersAndSort/DesktopFilter';
import careerFilterOptions from '../../../lib/config/project/careerFilterOptions';
import careerSortOptions from '../../../lib/config/project/careerSortOptions';
import useSeeAllReuslts from '../../../lib/hooks/seeAllResults';
import useUpdatePotentialFilterForParam from '../../../lib/hooks/updatePotentialFilterForParam';
import { Sort } from '../../../lib/types';
import DesktopSort from '../../shared/DesktopSort';

interface FiltersProps {
  potentialFilters: any;
  setPotentialFilters: Dispatch<any>;
  setPage: Dispatch<number>;
  setSelectedSort: Dispatch<Sort>;
  selectedSort: Sort;
  isCareers?: boolean;
  potentialNumberOfResults: number;
}

const DesktopFiltersAndSort: React.FC<FiltersProps> = ({
  potentialFilters,
  selectedSort,
  setSelectedSort,
  setPotentialFilters,
  setPage,
  isCareers,
  potentialNumberOfResults
}) => {
  const router = useRouter();

  const { updatePotentialFilterForParam } = useUpdatePotentialFilterForParam(
    potentialFilters,
    setPotentialFilters,
  );

  const { seeAllResults } = useSeeAllReuslts(
    setPage,
    potentialFilters,
    'careerguide',
  );

  const applySort = (option: Sort) => {
    router.query.sortBy = option.value;
    setSelectedSort(option);
    setPage(1);
    router.replace(router, undefined, { scroll: false });
  };
  return (
    <>
      <section className="hidden w-full -mb-4 lg:block">
        <div className="ml-auto w-fit">
          <DesktopSort
            selectedSort={selectedSort}
            sortOptions={careerSortOptions}
            applySort={applySort}
            isCareers={isCareers}
          />
        </div>
      </section>


      <div className="flex items-stretch h-10 pt-10 pb-16 lg:py-16">
        {careerFilterOptions.map((filter) => {
          return (
            <div className="flex-1 hidden mr-4 lg:flex">
              <DesktopFilter
                paramLabel={filter.paramLabel}
                label={filter.label}
                isMultiple={filter.paramLabel != 'length'}
                filterOptions={filter.options}
                updatePotentialFilterForParam={updatePotentialFilterForParam}
                potentialNumberOfResults={potentialNumberOfResults || 0}
                seeAllResults={seeAllResults}
                setPage={setPage}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DesktopFiltersAndSort;
